function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVarning = function SvgVarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.231 20.904"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1758"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-451.769 2677.9H-475l11.5-20.9 11.733 20.9Zm-11.852-3.953a1.05 1.05 0 0 0-.765.32 1.04 1.04 0 0 0-.32.758 1.06 1.06 0 0 0 .312.781 1.06 1.06 0 0 0 .773.312 1.05 1.05 0 0 0 .766-.312 1.06 1.06 0 0 0 .32-.773 1.05 1.05 0 0 0-.32-.766 1.05 1.05 0 0 0-.767-.317Zm-.882-10.11v9.375h1.765v-9.375Z",
    "data-name": "Exclusion 41",
    style: {
      fill: "#fff"
    },
    transform: "translate(475 -2657)"
  })));
};
export default SvgVarning;